<template>
  <div class="preview-canvas">
    <!-- <div><img :src="saveImg" alt="" /></div> -->
    <canvas
      id="canvasNode"
      ref="canvasRef"
      width="220px"
      height="72px"
    ></canvas>
  </div>
</template>

<script>
export default {
  name: "previewCanvas",
  data() {
    return {
      config: {
        family: "STHeitiSC-Light", // 默认的字体(黑体)
        text: "",
        size: "22px", // 默认的字号
        color: "#409EFF", // 默认颜色
        weight: "normal", // 默认粗细正常
        image: "",
        italic:"normal"
      },
      width: "",
      height: "",
      canvas: null, // canvas 实例
      ctx: null, // 画布实例
      saveImg: "",
    };
  },
  computed: {
    canvasRef() {
      return this.$refs.canvasRef;
    },
  },
  mounted() {
    this.createCanvas();
  },
  methods: {
    createCanvas() {
      this.canvas = this.canvasRef;
      this.ctx = this.canvas.getContext("2d");
      this.canvas.style.padding = "0";
      this.canvas.style.margin = "0";

      //   this.canvas.style.backgroundColor = "#A5F4A9";

      this.width = this.canvas.width;
      this.height = this.canvas.height;

      //   this.updateText("测试测试");
    },
    // 获取输入文本的实际宽度
    getActualWidth(text) {
      const { actualBoundingBoxLeft, actualBoundingBoxRight } =
        this.ctx.measureText(text);
      return actualBoundingBoxLeft + actualBoundingBoxRight;
    },
    // 获取输入文本的实际高度
    getActualHeight(text) {
      const { actualBoundingBoxAscent, actualBoundingBoxDescent } =
        this.ctx.measureText(text);
      return actualBoundingBoxAscent + actualBoundingBoxDescent;
    },
    // 更新canvas
    updatePreview() {
      const {
        text = "英文听力",
        italic,
        color,
        size,
        family,
        weight,
        image,
      } = this.config;

      this.clearRect();
      this.setCommonAttr();
      this.ctx.font =`${italic} ${weight} ${size} ${family}`
      // this.ctx.font = `${weight} ${size} ${family}`;

      // 绘制图片
      if (image) {
        this.drawImg(image);
      }

      if (!text) {
        // this.$message.warning("请先输入文字");
        return;
      }

      this.ctx.fillStyle = color;

      this.ctx.fillText(
        text,
        (this.width - this.getActualWidth(text)) / 2 +
          this.ctx.measureText(text).actualBoundingBoxLeft, // 修正部分字体不由水平中线(center)均分导致的位移
        (this.height - this.getActualHeight(text)) / 2 +
          this.ctx.measureText(text).actualBoundingBoxAscent // 修正部分字体不由垂直中线(middle)均分导致的位移
      );
    },
    // 绘制图片
    drawImg(image) {
      // 2 如果图片不为圆角，则需要绘制圆角 执行下这两个方法
      // this.roundRect(this.ctx, 0, 0, this.width, this.height, 12);
      // this.ctx.clip();
      // 海报绘制到裁切后的画布上
      // 1 如果图片为圆角 直接执行
      this.ctx.drawImage(
        image,
        0,
        0,
        image.naturalWidth,
        image.naturalHeight,
        0,
        0,
        this.width,
        this.height
      );
    },
    // 画圆角
    roundRect(ctx, x, y, width, height, radius) {
      ctx.moveTo(x + radius, y);
      ctx.lineTo(x + width - radius, y);
      ctx.arc(
        x + width - radius,
        y + radius,
        radius,
        1.5 * Math.PI,
        2 * Math.PI
      );
      ctx.lineTo(x + width, y + height - radius);
      ctx.arc(
        x + width - radius,
        y + height - radius,
        radius,
        0,
        0.5 * Math.PI
      );
      ctx.lineTo(x + radius, y + height);
      ctx.arc(
        x + radius,
        y + height - radius,
        radius,
        0.5 * Math.PI,
        1 * Math.PI
      );
      ctx.lineTo(x, y + radius);
      ctx.arc(x + radius, y + radius, radius, 1 * Math.PI, 1.5 * Math.PI);
    },
    // 获取图片地址
    getCanvasImage() {
      // console.log(this.config.text);
      // if (this.config.text == "") {
      // }
      //   this.saveImg = this.canvas.toDataURL("image/png");
      return new Promise((resolve, reject) => {
        if (!this.ctx) reject("预览图生成失败 -- canvas未创建");
        if (!this.config.text) {
          // this.$Message.warning("文字不能为空!");
          this.$message.warning("文字不能为空!");
          return;
        }
        this.canvas.toBlob((blob) => {
          if (blob) {
            
            // this.saveImg = window.URL.createObjectURL(blob);
            resolve({
              previewBlobUrl: window.URL.createObjectURL(blob), // 预览图本地链接
              previewBlob: blob,
            });
          } else {
            reject(new Error("预览图生成失败"));
          }
        });
      });
    },
    /**
     * 设置文字的通用属性
     * @param {}
     */
    setCommonAttr() {
      this.ctx.textAlign = "center";
      this.ctx.textBaseline = "middle";
    },

    // 通用更新canvas绘制状态
    updateCanvas(val, key) {
      // debugger;
      this.config[key] = val;
      // this.$nextTick(() => {
      this.updatePreview();
      // })
    },
    /**
     * 清楚画布
     */
    clearRect() {
      if (this.ctx) {
        this.ctx.clearRect(0, 0, this.width, this.height);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.preview-canvas {
  margin-top: 15px;
  canvas {
    box-sizing: border-box;
    // border: 1px solid #66b1ff;
    border-radius: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// previewCanvas.vue?63566661